import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Fuente Inter self-hosted via @fontsource (ADR-024).
// Pesos: 400 (body), 600 (medium UI), 700 (semibold), 800 (headings hero).
// font-display: swap incluido por defecto en @fontsource — evita FOIT.
// Workbox precachea los woff2 (globPatterns incluye woff2) → offline-safe.
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';

import { App } from './App.js';
import { AuthProvider } from './auth/AuthContext.js';
import { startSyncScheduler } from './offline/sync.js';
import './index.css';

// Boot del scheduler de sincronizacion offline. Es idempotente y
// chequea la presencia de la key AES en cada tick; sin key, no hace
// nada (la app sigue funcionando como antes).
startSyncScheduler();

// PWA: auto-recarga tras un deploy. El SW está en modo autoUpdate +
// skipWaiting + clientsClaim, así que un SW nuevo toma control y dispara
// `controllerchange`. Recargamos una vez para servir los assets frescos y
// evitar que el usuario quede con un bundle viejo cacheado (necesitando
// Ctrl+Shift+R manual). `hadController` evita recargar en la PRIMERA
// instalación (visitante nuevo): solo recargamos cuando es una actualización.
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  const hadController = navigator.serviceWorker.controller !== null;
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing || !hadController) return;
    refreshing = true;
    window.location.reload();
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('No se encontro el elemento #root en el DOM');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
